import { AppShell } from '../AppShell';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import StarBorderIcon from '@mui/icons-material/StarBorder';

export const AppShellDefaultLayout = ({
  children,
  rootPath,
}: Readonly<{
  children: React.ReactNode;
  rootPath: string;
}>) => (
  <AppShell
    rootPath={rootPath}
    toolbarActions={
      <>
        <Tooltip title="Favorites">
          <IconButton
            component={Link}
            to="/home/favorites"
            sx={{ color: 'text.primary' }}
          >
            <StarBorderIcon />
          </IconButton>
        </Tooltip>
      </>
    }
  >
    {children}
  </AppShell>
);
